import { render, staticRenderFns } from "./UserAvatarDisplay.vue?vue&type=template&id=812a26fa&scoped=true&"
import script from "./UserAvatarDisplay.vue?vue&type=script&lang=js&"
export * from "./UserAvatarDisplay.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarDisplay.vue?vue&type=style&index=0&id=812a26fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812a26fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VAvatar,VBadge})
